/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { CreateCourseSectionActivityOptions, CreateCourseSectionActivityStatus200, CreateCourseSectionActivityStatus422 } from '../models/CreateCourseSectionActivity'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { createCourseSectionActivity } from '../clients/axios/createCourseSectionActivity'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const createCourseSectionActivityMutationKey = () => [{ url: '/admin/course/activity/create' }] as const

export function createCourseSectionActivityMutationOptions<TContext = unknown>(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const mutationKey = createCourseSectionActivityMutationKey()
  return mutationOptions<CreateCourseSectionActivityStatus200, ResponseErrorConfig<CreateCourseSectionActivityStatus422>, CreateCourseSectionActivityOptions, TContext>({
    mutationKey,
    mutationFn: async({ body }) => {
      return await createCourseSectionActivity({ ...config, body, throwOnError: true })
    },
  })
}

/**
 * @summary Create Course Section Activity
 * {@link /admin/course/activity/create}
 */
export function useCreateCourseSectionActivity<TContext>(options: {
  mutation?: UseMutationOptions<CreateCourseSectionActivityStatus200, ResponseErrorConfig<CreateCourseSectionActivityStatus422>, CreateCourseSectionActivityOptions, TContext> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>,
} = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? createCourseSectionActivityMutationKey()

  const baseOptions = createCourseSectionActivityMutationOptions(config) as UseMutationOptions<CreateCourseSectionActivityStatus200, ResponseErrorConfig<CreateCourseSectionActivityStatus422>, CreateCourseSectionActivityOptions, TContext>

  return useMutation<CreateCourseSectionActivityStatus200, ResponseErrorConfig<CreateCourseSectionActivityStatus422>, CreateCourseSectionActivityOptions, TContext>({
    ...baseOptions,
    mutationKey,
    ...mutationOptions,
  }, queryClient) as UseMutationResult<CreateCourseSectionActivityStatus200, ResponseErrorConfig<CreateCourseSectionActivityStatus422>, CreateCourseSectionActivityOptions, TContext>
}
